import SEO from "@/components/SEO";
export default function TermsOfUsePage() {
  return (
    <div className="min-h-screen bg-white text-black px-6 md:px-20 pt-32 pb-12">
      <SEO
        title="Terms of Use | VANCO"
        description="The terms and conditions that govern your use of the VANCO website and its content."
        path="/terms-of-use"
      />
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-semibold mb-10">Terms of Use</h1>

        <h3 className="text-xl font-normal mb-4">1. Acceptance of Terms</h3>
        <p className="mb-4 font-light">
          When you access this site, you acknowledge that you have read and agree to abide by the terms described below. If you do not agree to the terms discussed here, you
          should exit this site now. </p>

        <h3 className="text-xl font-normal mt-10 mb-4">Copyright Notice</h3>
        <p className="mb-4 font-light">
          Everything on this site is copyrighted. The copyrights are owned by VANCO (&quot;VANCO&quot;, implies VANCO and all companies wholly or partially owned by it) or the original
          creator of the material. However, you are free to view, copy, print, and distribute VANCO material from this site, as long as:
        </p>
        <ul className="list-disc pl-6 mb-6 space-y-2 font-light">
          <li>The material is used for information only</li>
          <li>The material is used for non-commercial purposes only.</li>
          <li>Copies of any material include VANCO copyright notice.</li>
        </ul>

        <h3 className="text-xl font-normal mt-10 mb-4">Third Party Copyrights and Copyright Agent</h3>
        <p className="mb-4 font-light">
          The VANCO is committed to respecting others&apos; intellectual property rights, and we ask our users to do the same. The VANCO may, in its sole
          discretion, terminate the accounts or access rights of users who violate others&apos; intellectual property rights.
        </p>
        <p className="mb-4 font-light">
          If you believe that your work has been copied in a way that constitutes copyright infringement on our Web site, please deliver the following information to the VANCO:
        </p>
        <ul className="list-disc pl-6 mb-6 space-y-2 font-light">
          <li>An electronic or physical signature of the person authorized to act on behalf of the copyright owner;</li>
          <li>A description of the copyrighted work that you claim has been infringed;</li>
          <li>A description of where the material that you claim is infringing is located on our Web site;</li>
          <li>Your address, telephone number, and email address so that we may contact you;</li>
          <li>A statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law; and</li>
          <li>A statement by you, made under penalty of perjury, that the information in your notice to us is accurate and that you are the copyright owner or authorized to act on
            the copyright owner&apos;s behalf.</li>
        </ul>

        <p className="mb-4 font-light">Please send this information to - VANCO, 4th Floor, Block A, BHIVE Premium HSR Campus, AKR Tech Park, 7th Mile, Hosur Road, Bengaluru, Karnataka 560068</p>

        <h3 className="text-xl font-normal mt-10 mb-4">Trademarks</h3>
        <p className="mb-4 font-light">
          The VANCO Logo is a trademark of Vanco. You may not use these without the written permission of Vanco.
        </p>

        <h3 className="text-xl font-normal mt-10 mb-4">No Warranty</h3>
        <p className="mb-4 font-light">
          While VANCO attempts to provide accurate information on this Web site, it assumes no responsibility for accuracy. The VANCO may change the information on the site at any
          time without notice.
        </p>

        <p className="mb-4 font-light">
          Material on this site is provided &quot;as is&quot; and does not constitute a warranty of any kind, either expressed or implied. VANCO disclaims all warranties, expressed or implied.
          This includes but is not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement. It also includes any expressed or implied
          warranties arising from any course of dealing, usage, or trade practice.
        </p>

        <h3 className="text-xl font-normal mt-10 mb-4">Limitation of Liability</h3>
        <p className="mb-4 font-light">
          VANCO is not liable for any direct, indirect, special, incidental, or consequential damages arising out of the use-or the inability to use-the material on this site.
          This includes but is not limited to the loss of data or loss of profit, even if VANCO was advised of the possibility of such damages.
        </p>

        <h3 className="text-xl font-normal mt-10 mb-4">Links</h3>
        <p className="mb-4 font-light">
          While this Web site may contain links to third-party sites, VANCO is not responsible for the content of any linked sites.
        </p>

        <h3 className="text-xl font-normal mt-10 mb-4">Your Posted Information</h3>
        <p className="mb-4 font-light">
          You are prohibited from posting or transmitting any unlawful, threatening, obscene, libelous, or otherwise offensive material.
        </p>

        <h3 className="text-xl font-normal mt-10 mb-4">Your Submission</h3>
        <p className="mb-4 font-light">
          Any material, information, or idea submitted or posted on this Web site will be considered non-confidential and non-proprietary. VANCO may share or otherwise use your
          submission for any purpose whatsoever. If any of the information submitted constitutes personal data, you agree that VANCO may transmit such personal data across
          international boundaries for any VANCO business purpose. Personal data will be treated as set forth in our Privacy Statement.
        </p>

        <p className="font-light">
          Jurisdiction and Choice of Law All claims or issues regarding this Web site, shall be governed according to the laws of the State of Maharashtra, India. Any legal
          action concerning these Terms or this Web site must be brought within one (1) year after the claim or cause of action arises and must be brought in the State of Maharashtra.
        </p>
      </div>
    </div>
  );
}
